module.exports = __webpack_public_path__ + "img/1440.fcbd273f.jpg";